import { ICompetitionRanking, ICompetitionRankingList } from '@sky-it-livedata/livedata-sports-design-system';
import { isNotEmptyArray, slugify } from '@sky-it-livedata-libraries/livedata-commons';
import { isValidTeamRanking } from './typeguards';
import { CreateTeamRankingInputSchema } from 'appsync';
import { WidgetError, ErrorName } from '../../../utils/errors';
import { TeamRankingQuery } from '../types';
import { intcmpMap } from '../../../utils/intcmp';
import { isNotNull } from '../../../utils/tests';

export const getTrackingData = (
  trackingKey: string,
  trackingString: [string, string],
  trackingValues: Array<any>
): Array<any> => {
  return trackingValues
    .filter((r): r is { customCompetitionName: string } => !!r && !!r.customCompetitionName)
    .map((r) => ({
      [trackingKey]: `${trackingString[0]}${slugify(r.customCompetitionName)}${trackingString[1]}`,
    }));
};

export default (obj: TeamRankingQuery): ICompetitionRanking=> {
  if (isValidTeamRanking(obj)) {
    CreateTeamRankingInputSchema().parse(obj.data.getTeamRanking, {reportInput: true});
      const { rankingLists = [], teamId } = obj.data.getTeamRanking;
      const { dataAttribute, ranking, value } = intcmpMap.teamRanking;
      const rankingMap = (rankingLists!).filter(isNotNull).map((ranking) => {
        const { competitionId, customCompetitionName = '', seasonId, groups = [] } = ranking;
        return {
          competitionId,
          customCompetitionName,
          seasonId,
          // In GROUPS array there's 1 OBJECT ONLY because TEAM can't be in MORE than ONE competition of same type (e.g. CHAMPIONS LEAGUE), so [0] index is safe
          roundName: isNotEmptyArray(groups) ? (groups![0]!.roundName ?? 'unico') : 'unico',
          teams: isNotEmptyArray(groups)
            ? ((groups![0]!.teams ?? []).map((team) => ({
                ...team,
              })))
            : [],
        };
      }) as ICompetitionRankingList[];

      return {
        teamId,
        rankingLists: rankingMap,
        trackingDataList: getTrackingData(dataAttribute, [ranking, value], rankingMap),
      };
  } else {
    throw new WidgetError<ErrorName>({
      name: 'NO_VALID_DATA',
      message: 'Invalid transformer input, Error in TeamRankingQuery object',
      data: obj
    });
  }
};